<template>
    <div class="sideBar" ref="draggableContainer" @mousedown="handlePositionChange($event)" v-click-outside="(e)=>{
                if(this.outsideDisabed && !e.shiftKey) { return }
                this.close(false)
            }" 
            :class="{
                'sideBar_type_active':show,
                'sideBar_type_draggaable': !isPin
            }"
            :style="{top: this.$store.getters.barTopPosition ? this.$store.getters.barTopPosition+'px' : null}"
        >
        <template v-if="!isPin">
            <div class="draggable__border draggable__border-top" @mousedown.stop="handleResizeUp($event)"></div>
            <div class="draggable__border draggable__border-right" @mousedown.stop="handleResizeRight($event)"></div>
            <div class="draggable__border draggable__border-bottom" @mousedown.stop="handleResizeDown($event)"></div>
            <div class="draggable__border draggable__border-left" @mousedown.stop="handleResizeLeft($event)"></div>
            <div class="draggable__coner draggable__coner-top_left" @mousedown.stop="handleResizeTopLeft($event)"></div>
            <div class="draggable__coner draggable__coner-top_right" @mousedown.stop="handleResizeTopRight($event)"></div>
            <div class="draggable__coner draggable__coner-bottom_left" @mousedown.stop="handleResizeBottomLeft($event)"></div>
            <div class="draggable__coner draggable__coner-bottom_right" @mousedown.stop="handleResizeBottomRight($event)"></div>
        </template>
        <div class="sideBar__left-panel" @mousedown.stop>
            <slot name="left-panel" />
        </div>
        <div class="sideBar__wrapper" :class="{ 'sideBar__wrapper_panel-open': leftPanelOpen && !isPin }">
            <div class="sideBar__container" ref="draggableContent">
                <div class="sideBar__header">
                    <slot name="header">
                    </slot>
                    <div class="sideBar__tools">
                        <slot name="tools"></slot>
                        <button v-if="draggable" class="button sideBar__button sideBar__button-pin button_with_icon button_type_icon" 
                            @click="handleTogglePin">
                            <svg aria-hidden="true" width="20" height="20" v-if="isPin">
                                <use href="#icon-win-unpin"></use>
                            </svg>
                            <svg aria-hidden="true" width="20" height="20" v-else>
                                <use href="#icon-win-pin"></use>
                            </svg>
                        </button>
                        <button class="button sideBar__button button_with_icon button_type_icon" @click="hendleCloseClick">
                            <svg aria-hidden="true" width="20" height="20">
                                <use href="#icon-close"></use>
                            </svg>
                        </button>
                    </div>
                </div>

                <div class="sideBar__body" @mousedown.stop>
                    <slot name="body">
                    </slot> 
                </div>

                <div class="sideBar__footer" @mousedown.stop v-if="!disabledFooter">
                    <slot name="footer">
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>


<script> 
import mixinDraggable from './draggable.js'
import { mapActions } from 'vuex';
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        outsideDisabed: {
            type: Boolean,
            default: false
        },
        draggable: {
            type: Boolean,
            default: false
        },
        disabledFooter: {
            type: Boolean,
            default: false
        },
        sbName: {
            type: String,
            default: 'custom'
        },
        leftPanelOpen: {
            type: Boolean,
            default: false,
        },
    },
    mixins: [mixinDraggable],
    data () {
        return {
            isPin: true,
        }
    },
    mounted() {
        //this.SET_BAR({ name: this.sbName, value: this.show })
        document.addEventListener('keydown', (event) => {
            if (event.keyCode === 27) {
                this.close(true)
                this.isPin = true
                this.resetPosition()
            }
        });
        
        window.addEventListener('resize', () => {
            this.keepWindowOnScreen();
        });
        
    },
    beforeDestroy() {
        this.close(false)
        //this.HARD_RESET_SIDEBAR()
    },
    methods: {
        ...mapActions(['TOPBAR_SET_PADDINGRIGHT', 'HARD_RESET_SIDEBAR', 'SET_BAR']),
        close(value) {
            // this.SET_BAR({ name: this.sbName, value: false })
            this.$emit('hide',value)
        },
        hendleCloseClick() {
            this.$emit('hide')
            // this.isPin = true
            // this.refreshPosition()
            // this.close()
        },
        handleTogglePin() {
            this.isPin = !this.isPin
            this.refreshPosition()
            this.$emit('pin', this.isPin)
        },
        refreshPosition() {
            if(this.isPin) {
                this.resetPosition()
            } else {
                this.setDynamicPosition()
            }
        }, 
        resetPosition() {
            const draggableContainer = this.draggableContainer
            draggableContainer.classList.remove('sideBar_type_draggaable')
            

            this.$nextTick(() => {
                draggableContainer.style.left = (document.querySelector('body').clientWidth - 420) +'px'
                draggableContainer.style.top = '63px'
                draggableContainer.style.height = (document.querySelector('body').clientHeight - 63) +'px'
                draggableContainer.style.width = '420px'
                
                setTimeout(() => {
                    draggableContainer.style.left = null
                    draggableContainer.style.top = null
                    draggableContainer.style.height = null
                    draggableContainer.style.width = null
                    draggableContainer.style.zIndex = null
                }, 400);
            })
        },
        setDynamicPosition() {
            
            const draggableContainer = this.$refs.draggableContainer
            const rect = draggableContainer.getBoundingClientRect()
            draggableContainer.style.left = rect.left + 'px'
            draggableContainer.style.top = rect.top + 'px'
            draggableContainer.style.width = rect.width + 'px'
            draggableContainer.style.zIndex = 1000


            this.$nextTick(() => {
                const draggableContent = this.$refs.draggableContent
                const contRect = draggableContent.getBoundingClientRect()
                draggableContainer.style.height = contRect.height+64 + 'px'
            })
        },
        keepWindowOnScreen() {
            if(!this.show || this.isPin) return;
            const draggableContainer = this.$refs.draggableContainer;
            if (!draggableContainer) return;

            const rect = draggableContainer.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            let newLeft = rect.left;
            let newTop = rect.top;

            // Проверка по горизонтали
            if (rect.left < 0) {
                newLeft = 0;
            } else if (rect.right > viewportWidth) {
                newLeft = viewportWidth - rect.width;
            }

            // Проверка по вертикали
            if (rect.top < 0) {
                newTop = 0;
            } else if (rect.bottom > viewportHeight) {
                newTop = viewportHeight - rect.height;
            }

            draggableContainer.style.left = `${newLeft}px`;
            draggableContainer.style.top = `${newTop}px`;
        }

    }

}
</script>

<style lang="scss">
@import '../../../../gulp-src/app/scss/_variables';
@import '../../../../gulp-src/app/scss/_mixins';

.sideBar {
    max-width: 100%;
    $width:420px;
    position: fixed;
    top: $logo-height+10px;
    bottom: 0;
    //right: -$width;
    right: 0;
    display: flex;
    z-index: 99;
    left: auto;
    overflow: visible;
    transition: .2s;
    box-shadow: 0 0 0 rgba(58, 65, 70, 0.12), 0 0 0 rgba(58, 65, 70, 0.06);

    @media screen and (max-width: $breakpoint-sm) {
        width: 100%;
    }

    &_type{
        &_active {
            // box-shadow: -8px 0 16px rgba(58, 65, 70, 0.12), -4px 0 12px rgba(58, 65, 70, 0.06);
            box-shadow: 0 8px 16px rgba(58, 65, 70, 0.12), 0 4px 12px rgba(58, 65, 70, 0.06);
            right: 0;
        }
        &_draggaable {
            transition: .0s;
            border-radius: 16px;
            border: 1px solid #CBCCCF;
            box-shadow: 0px 4px 8px rgba(58, 65, 70, 0.06), 0px 8px 24px rgba(58, 65, 70, 0.06);

            cursor: move;
            .sideBar__wrapper {
                width: 100%;
                border-radius: 16px;
                overflow: hidden;

                &_panel-open {
                    border-radius: 0 16px 16px 0;
                }
            }
            .sideBar__left-panel {
                border-radius: 16px 0 0 16px;
            }
        }
    }

    &__left-panel {
        position: absolute;
        right: 100%;
        top: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    &__wrapper{
        width: 100%;
        background-color: #fff;
        display: flex;
        overflow: hidden;
        @include scrollbar();

        padding: 16px;
        @media (min-width: #{$breakpoint-sm}) {
            width: $width;
        }
    }

    &__header,
    &__body,
    &__footer {
        margin-bottom: 16px;
    }

    &__footer {
        margin-top: auto;
        margin-bottom: 0;
        padding-bottom: 16px;
    }

    &__header{
        display: flex;
    }

    &__header p {
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        color: #0A0A17;
    }

    &__body {
        height: 100%;
        //max-height: calc(100% - 92px);
        max-height: calc(100% - 72px);
    }

    &__container {
        width: 100%;
        position: relative;
        z-index: 2;
        cursor: default;
        display: flex;
        flex-direction: column;
    }
    &__tools {
        margin-left: auto;
        display: flex;
        flex-wrap: nowrap;
        margin-top: auto;
        margin-bottom: auto;
        gap: 5px;

        .button {
            min-width: unset;
        }
    }
    & &__button {
        width: 20px;
        height: 20px;
        color: #919197;
        
        &-pin {
            color: #3A4146;
        }
        
        svg {
            margin-left: 0;
            margin-right: 0;
            fill: currentColor;
        }
    }
}

.sideSwipe {
    &-enter-active, &-leave-active {
        transition: all 1s;
    }
    &-enter, &-leave-to{
        margin-left: 100%;
    }
    &-move {
        transition: all 1s;
    }
}

.draggable {
  &__border {
    position: absolute;
    z-index: 3;
    
    &-top,&-bottom {
      width: 100%;
      height: 10px;
      cursor: n-resize;
    }
    &-bottom {
      bottom: 0;
    }
    
    &-left,&-right {
      width: 10px;
      height: 100%;
      cursor: w-resize;
    }
    &-right {
      right: 0;
    }
  }
  &__coner{
    width: 20px;
    height: 20px;
    z-index: 3;
    position: absolute;
    &-top_right, &-bottom_left {
        cursor: ne-resize;
    }
    &-top_left, &-bottom_right{
        cursor: nw-resize;
    }
    &-top_left {
        top: 0;
        left: 0;
    }
    &-top_right {
        top: 0;
        right: 0;
        
    }
    &-bottom_left {
        bottom: 0;
        left: 0;
    }
    &-bottom_right {
        bottom: 0;
        right: 0;
    }
  }
}

</style>